import { PatchBlock, ReadBlock } from '@tinct/core-api-models';
import { ApiClient } from '../api-client/api-client';
import { FieldQuery } from '../types';

export class BlocksEndpoint {
  constructor(private client: ApiClient) {}

  /**
   * Partial update of a single block. Editing a block (the personalization
   * `enabled` toggle included) is a serve-time publish input: the server flags
   * the campaign's published pages `needs_republication` — it never triggers a
   * variant regeneration.
   */
  async patchBlock(
    blockId: string,
    data: PatchBlock,
    fields?: FieldQuery<ReadBlock>,
  ): Promise<ReadBlock> {
    return this.client.patch<ReadBlock>(
      `/api/v1/blocks/${blockId}`,
      data,
      fields,
    );
  }
}
